/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingIdCancelMutationResponse, PostApiBookingIdCancelPathParams, PostApiBookingIdCancelQueryParams } from "../entities/PostApiBookingIdCancel";

function getPostApiBookingIdCancelUrl(id: PostApiBookingIdCancelPathParams["id"]) {
  const res = { method: 'POST', url: `/api/booking/${id}/cancel` as const }
  return res
}

/**
 * @description Отмена записи на стрижку
 * @summary Отменить запись
 * {@link /api/booking/:id/cancel}
 */
export async function postApiBookingIdCancel(id: PostApiBookingIdCancelPathParams["id"], params: PostApiBookingIdCancelQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBookingIdCancelMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getPostApiBookingIdCancelUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}